import { render } from "./LoadingCard.vue?vue&type=template&id=3d565040"
import script from "./LoadingCard.vue?vue&type=script&lang=js"
export * from "./LoadingCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"LoadingCard.vue"]])

export default __exports__